import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { mdiChevronDown, mdiChevronUp } from '@mdi/js';

interface IProps {
  value?: boolean;
}

interface IEmits {
  (event: 'input', value: boolean): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChevronUpDown',
  props: {
    value: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'input', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value?: boolean;
};




const chevronUpDown = ref(props.value);

watch(chevronUpDown, (newValue, oldValue) => {
  if (newValue !== oldValue) emit('input', chevronUpDown.value || false);
});

watch(
  () => props.value,
  async (newValue, oldValue) => {
    if (newValue != oldValue) {
      chevronUpDown.value = newValue;
    }
  },
  { deep: true }
);

return { __sfc: true,props, emit, chevronUpDown, mdiChevronDown, mdiChevronUp }
}

})